module.exports = __webpack_public_path__ + "static/hotblack-tech-floorplan-e8f6130c7a7c28ef308b338185f280f2.png";